import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { PropType, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Tooltip',
  props: {
  content: {
    type: String,
    default: "",
  },
  wrapperClass: {
    type: String,
    default: "",
  },
  positionHorizontal: {
    type: String as PropType<"left" | "right">,
    default: "left",
  },
  positionVertical: {
    type: String as PropType<"top" | "bottom">,
    default: "bottom",
  },
},
  setup(__props) {



const showTooltip = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      ref: "slot",
      class: _normalizeClass(['group w-max relative', __props.wrapperClass]),
      onMouseover: _cache[0] || (_cache[0] = ($event: any) => (showTooltip.value = true)),
      onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (showTooltip.value = false))
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 34),
    _createElementVNode("span", {
      class: _normalizeClass([
      'pointer-events-none absolute w-max transition-opacity bg-gray-700 text-white px-1.5 rounded-sm py-0.5 text-[0.7rem] whitespace-pre-wrap transform',
      `${__props.positionHorizontal}-0`,
      showTooltip.value ? 'opacity-90' : 'opacity-0',
      __props.positionVertical === 'top' ? 'bottom-[120%]' : 'top-[120%]',
    ]),
      style: {"max-width":"220px"}
    }, _toDisplayString(__props.content), 3)
  ], 64))
}
}

})